import { OfChatMessagesService } from '@api'
import {
  attach,
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'
import debounce from 'lodash/debounce'

import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import { $messageIdToFetch } from '@/models/chattingUI/messages/messages.ts'
import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const resetSearchText = createEvent('set messages search text')
export const setSearchText = createEvent<string>('set messages search text')
export const setSearch = debounce(setSearchText, 500)
export const $searchText = createStore<string>('', {
  name: 'messages search text',
})
  .on(setSearchText, (_, text) => text)
  .reset(resetSearchText)

export const searchTextFx = attach({
  name: 'search fan messages by text',
  source: {
    fanId: $fanId,
    creatorId: $creatorId,
  },
  mapParams: (text: string, { fanId, creatorId }) => {
    return {
      creatorId: creatorId!,
      userId: fanId,
      text,
    }
  },
  effect: createEffect(OfChatMessagesService.searchMessage),
})

searchTextFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while searching message')
})

export const $searchedMessageIds = createStore<Nullable<number[]>>(null, {
  name: 'searched message ids',
})
  .on(searchTextFx.doneData, (_, { list }) => list)
  .reset(resetSearchText)

export const $searchResultIndex = combine(
  $searchedMessageIds,
  $messageIdToFetch,
  (messageIds, searchId) => {
    return searchId && messageIds ? messageIds.indexOf(searchId) : -1
  },
)

sample({
  clock: $searchText,
  filter: (text) => !!text,
  target: searchTextFx,
})
